import React from "react";
import { useSelector } from "react-redux";
import { ImgIcon } from "../../../assets";
import { remove } from "../../../assets/icons";
import QuantitySelector from "../../../assets/QuantitySelector";
import { useState } from "react";
import LookupField from "../../../assets/LookupField";
import { groupArrayByField, mergeObjectArrays } from "../../../helpers";

export default function OptionsTab({ values, onChange }) {

	const { addOns } = useSelector(state => ({ addOns: state.shop.addOns }));

	const [newOptionName, setNewOptionName] = useState("");
	const optionNameAllowed = Boolean(newOptionName && !values.options.find(o => o.name === newOptionName));

	const hasAnEmptyOption = Boolean(values.options.find(o => !o.addOns.length));

	return <div className="optionsTab">

		<div className="padded bordered">
			<h4>Options</h4>
			<div>
				<br />
				Options are great for highly configurable products, with rules around what can be picked.
				<br /><br />
				If you think of a pizza, you might have 2 options: <b>crust</b> and <b>toppings</b>. <b>Crust</b> would allow only one choice, whereas <b>toppings</b> would allow you to select multiple.
			</div>
		</div>

		<form className="padded add-option-type" onSubmit={e => {
			e.preventDefault();
			if (!optionNameAllowed) return;
			onChange({
				options: [...values.options, {
					name: newOptionName,
					addOns: [],
					maxCount: 0,
					minCount: 0
				}]
			});
			setNewOptionName("");
		}}>
			<input
				style={{ fontSize: "inherit" }}
				placeholder={!values.options.length ? "Type here to add your first option type." : "Type here to add another option type."}
				className="padded"
				value={newOptionName}
				onChange={e => setNewOptionName(e.target.value)}
				type="text"
			/>
			<input
				type="submit"
				className="button normalFont text-center"
				disabled={!optionNameAllowed}
				value="+"
			/>
		</form>

		{values.options.map(option => <OptionSet
			key={option.name}
			option={option}
			addOns={addOns}
			onRemove={e => onChange({
				options: values.options.filter(o => option.name !== o.name)
			})}
			onChange={changedOption => onChange({
				options: values.options.map(o => o.name === option.name ? changedOption : o)
			})}
		/>)}

		{hasAnEmptyOption && <div className="error text-center padded">
			You have an empty option. Add entries to it or remove it with the bin icon.
		</div>}

	</div>
}

const iconSettings = {
	size: 30,
	iconSize: "65%",
	bg: "#f7f7f7"
}

function OptionSet({ option, addOns, onChange, onRemove }) {

	return <div className="option" key={option.name}>
		<div className="optionHeader featureFont padded">
			{option.name}
			<ImgIcon
				{...iconSettings}
				style={{ filter: "invert(1)" }}
				src={remove}
				title={"Remove option."}
				onClick={e => {
					if (!option.addOns.length || window.confirm("Are you sure? This will remove the add-ons configured too."))
						onRemove();
				}}
			/>
		</div>
		<div className="flexy bordered">
			<div className="minSetting v-middle padded featureFont">
				<label>Min</label>
				<QuantitySelector
					showWhenDisabled={true}
					value={option.minCount || 0}
					onChange={minCount => onChange({ ...option, minCount })}
				/>
			</div>
			<div className="maxSetting v-middle padded featureFont">
				<label>Max</label>
				<QuantitySelector
					showWhenDisabled={true}
					value={option.maxCount || 0}
					onChange={maxCount => onChange({ ...option, maxCount })}
				/>
			</div>
		</div>
		{option.addOns.map(({ addOn: addOnId, maxCount, minCount }) => {
			// Go get the full addOn object from global state.
			const addOn = addOns.find(addOn => addOn.id === addOnId);
			if (!addOn) return null;
			// Render a display for each.
			return <div
				title={addOn.id}
				className="option-addOn padded bordered"
				key={addOn.id}
			>
				<div className="flexy">
					<div className="name" style={{ flex: 2 }}>
						{addOn.name}
					</div>
					<div className="price">
						£{(addOn.price / 100).toFixed(2)}
					</div>
					<div className="addOn-controls text-right" style={{ fontSize: 0 }}>
						<ImgIcon
							{...iconSettings}
							src={remove}
							title={"Remove add-on."}
							onClick={e => onChange({
								...option,
								addOns: option.addOns.filter(a => a.addOn !== addOnId)
							})}
						/>
					</div>
				</div>
				<div className="flexy">
					{/* <div className="minSetting v-middle">
						<label>Min</label>
						<QuantitySelector
							showWhenDisabled={true}
							value={minCount || 0}
							onChange={minCount => onChange({
								...option,
								addOns: option.addOns.map(a => a.addOn === addOnId ? {
									...a,
									minCount
								} : a)
							})}
						/>
					</div> */}
					<div className="maxSetting v-middle">
						<label>Max</label>
						<QuantitySelector
							showWhenDisabled={true}
							value={maxCount || 0}
							onChange={maxCount => onChange({
								...option,
								addOns: option.addOns.map(a => a.addOn === addOnId ? {
									...a,
									maxCount
								} : a)
							})}
						/>
					</div>
				</div>
			</div>
		})}
		<div className="addAddOn padded bordered">
			<LookupField
				placeholder="Search add-ons to add them.."
				items={[
					// Create option for selecting whole categories.
					...Object.entries(groupArrayByField(addOns, "category"))
						.filter(([category, items]) => category && category !== "null" && items.length)
						.map(([category, items]) => ({
							id: category,
							name: category,
							price: 0,
							isMultiple: true,
							items,
						})),
					// And all the standard ones.
					...addOns.filter(addOn => !option.addOns.find(a => a.addOn === addOn.id))
				]}
				comparator={(searchString, item) => item.name.toLowerCase().includes(searchString.toLowerCase())}
				renderItem={item => item.isMultiple ?
					(
						<div className="flexy padded featureFont" style={{
							fontSize: "1.1rem"
						}}>
							<b>{item.name}</b>
							<b className="brand-c">Add {item.items.length} item{item.items.length === 1 ? "" : "s"}</b>
						</div>
					) : (
						<div className="flexy padded">
							<span>{item.name}</span>
							<span>£{(item.price / 100).toFixed(2)}</span>
						</div>
					)
				}
				onChange={selection => {
					// Handle multiple selection type.
					if (selection.isMultiple) {
						onChange({
							...option,
							addOns: mergeObjectArrays(
								selection.items.map(addOn => ({
									addOn: addOn.id,
									maxCount: 0,
									minCount: 0
								})),
								option.addOns,
								(a, b) => a.addOn === b.addOn
							)
						})
					} else {
						onChange({
							...option,
							addOns: [...option.addOns, {
								addOn: selection.id,
								maxCount: 0,
								minCount: 0
							}]
						})
					}
				}}
			/>
		</div >
	</div >
}
